import ReactDOM from "react-dom";

const ErrorPopUpPortal = ({ children }: any) => {
    const ErrorPopUpRoot = document.getElementById("error-popup-root");
    return ErrorPopUpRoot && ReactDOM.createPortal(children, ErrorPopUpRoot);
};

export default ErrorPopUpPortal;
